export default "__VITE_ASSET__BcJK2HtG__"